// Reducers
import {
  ADD_SUBRECORD,
  IAddSubrecordAction,
  SET_SUBRECORDS,
  ISetSubrecordAction,
  SET_SUBRECORD_CONFIRMED_BY_BACKEND,
  ISetSubrecordConfirmedByBackendAction,
  DELETE_SUBRECORD,
  IDeleteSubrecordAction,
  CLEAR_SUBRECORDS,
  IClearSubrecordAction,
  ISubrecordsState,
} from './types';
import initialState from '../store/initialState';

type HandledActions = IAddSubrecordAction | ISetSubrecordAction | ISetSubrecordConfirmedByBackendAction | IDeleteSubrecordAction | IClearSubrecordAction;

export const subrecordsReducer = (state: ISubrecordsState = initialState.subrecords, action: HandledActions): ISubrecordsState => {
  switch (action.type) {
    // Set subrecords data.
    case SET_SUBRECORDS: {
      const { recordId, subrecords } = action.payload;
      return {
        ...state,
        subrecords: {
          ...state.subrecords,
          [recordId]: subrecords,
        },
      };
    }

    // Add a subrecord.
    case ADD_SUBRECORD: {
      const subrecord = { ...action.payload, created_at: new Date().toISOString() };
      const existingSubrecords = state.subrecords[subrecord.record_id] || [];

      if (existingSubrecords.some((sr) => sr.subrecord_id === subrecord.subrecord_id)) {
        // eslint-disable-next-line no-console
        console.warn('[subrecordsReducer] ADD_SUBRECORD ignored duplicate subrecord', {
          record_id: subrecord.record_id,
          subrecord_id: subrecord.subrecord_id,
        });
        return state;
      }
      return {
        ...state,
        subrecords: {
          ...state.subrecords,
          [subrecord.record_id]: [subrecord, ...existingSubrecords],
        },
      };
    }

    // Delete subrecord
    case DELETE_SUBRECORD: {
      const { recordId, subrecordId } = action.payload;
      return {
        ...state,
        subrecords: {
          ...state.subrecords,
          [recordId]: state.subrecords[recordId]?.filter((subrecord) => subrecord.subrecord_id !== subrecordId) || [],
        },
      };
    }

    // Set subrecord as no longer on route
    case SET_SUBRECORD_CONFIRMED_BY_BACKEND: {
      const { recordId, subrecordId, data } = action;
      return {
        ...state,
        subrecords: {
          ...state.subrecords,
          [recordId]:
            state.subrecords[recordId]?.map((subrecord) =>
              subrecord.subrecord_id === subrecordId ? { ...subrecord, ...data, onroute: /*!data.ai_text ||*/ action.data.interim === true } : subrecord,
            ) || [],
        },
      };
    }

    // Clear all subrecords
    case CLEAR_SUBRECORDS: {
      return {
        ...state,
        subrecords: {},
      };
    }

    default:
      return state;
  }
};
